<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div class="grid sm:flex gap-3 mt-2 sm:flex-wrap">
      <div class="mt-2 report-box-2" :class="data.icon != 'sensitive' ? 'flex-1' : 'flex-1-5'" v-for="(data, key) in countCard" :key="key">
        <div class="box bg-white h-full">
          <div class="px-4 py-4 flex flex-col justify-center flex-1">
            <div class="flex items-center justify-between">
              <h3 class="font-bold text-primary-1 text-base">{{data.text}}</h3>

              <span
                class="
                  w-8
                  h-8
                  px-2
                  py-2
                  flex
                  items-center
                  justify-center
                  rounded-full
                  border-1
                  text-theme-17
                  ml-2
                  box-shadow
                "
              >
                <HomeIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'house'"
                />
                <UsersIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'family'"
                />
                <UserIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'member'"
                />
                <FrownIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'sensitive'"
                />
              </span>
            </div>

            <div class="relative text-5xl font-medium ml-0.5 mt-2 flex text-primary-1" v-if="data.icon != 'sensitive'">
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">บันทึก</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{new Intl.NumberFormat().format(data.recorded_count)}}</div>
              </div>
              <div class="left text-sm flex-1 text-center">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">อนุมัติ</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{new Intl.NumberFormat().format(data.approved_count)}}</div>
              </div>
            </div>
            <div class="relative text-5xl font-medium ml-0.5 mt-2 flex text-primary-1" v-else>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">0</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{new Intl.NumberFormat().format(data.level_0)}}</div>
              </div>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">1</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{new Intl.NumberFormat().format(data.level_1)}}</div>
              </div>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">2</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{new Intl.NumberFormat().format(data.level_2)}}</div>
              </div>
              <div class="left text-sm flex-1 text-center">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">3</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{new Intl.NumberFormat().format(data.level_3)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2 class="text-lg mb-2 mt-5">รายงานสรุปผลการจัดทำข้อมูลสมุดพกครอบครัวอิเล็กทรอนิกส์</h2>
    <DataTreeTable
      :api-params="paramsComputed"
      :api-url="'member/getReport1UserStats/'"
      :method-request="'POST'"
      :data-array-table="dataArrayTable"
      :key="key"
      :table-name="'report'"
      :init-sorter="[{column:'cm_uid',dir:'asc'}]"
      :custom-sort="[{column: 'name', relateColumn: ['surname']}]"
      :downloadCsv="downloadCsv"
      @downloadCsvComplete="$emit('downloadCsvComplete')"
      :downloadExcel="downloadExcel"
      @downloadExcelComplete="$emit('downloadExcelComplete')"
      reportName="รายงานสรุปผลการจัดทำข้อมูลสมุดพกครอบครัวอิเล็กทรอนิกส์"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
import DataTreeTable from "@/components/datatable/dataTreeDataTable.vue"
import dataReport from "../../example-data/json/report.json"
import { useStore } from 'vuex'
import axios from 'axios'
import Swal from "sweetalert2"

export default defineComponent({
  props:{
    filter:{
        type: Object
    },
    downloadCsv:{
      type: Boolean
    },
    downloadExcel:{
      type: Boolean
    }
  },
  components:{
    DataTreeTable
  },
  setup(props) {
    const params = ref({start: '1',draw: '1',length: '10'})
    const key = ref(1)
    const store = useStore()
    const token = store.getters["userAuth/getToken"]
    watch(()=>props.filter, ()=>{
      getOverAllReport()
      key.value++
    })
    const paramsComputed = computed(() => ({...params.value, ...props.filter}))
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.title ? data.title : ""}${data.name ? data.name: ""} ${data.surname ? data.surname : ""}`
    }
    var customIdentityMutator = (value, data, type, params, component) =>{
      if(data.cm_uid){
        return data.cm_uid;
      }else{
        return data.national_id
      }
    }
    /*var customProblemMutator = (value, data, type, params, component) => {
      if(data.memberinfo ? data.memberinfo.member_stats : false){
        return {"housing": data.memberinfo.member_stats.prob_housing, "health": data.memberinfo.member_stats.prob_health, "occupation": data.memberinfo.member_stats.prob_occupation, "education": data.memberinfo.member_stats.prob_education, "accessibility": data.memberinfo.member_stats.prob_accessibility}
      }else{
        return {"housing": 0, "health": 0, "occupation": 0, "education": 0, "accessibility": 0}
      }
    } */
    const dataArrayTable = reactive([
      {title:"รหัส/เลขบัตรประจำตัวประชาชน", field:"cm_uid", minWidth: 230, variableHeight: true, mutator: customIdentityMutator},
      {title:"ชื่อ-สกุลเจ้าหน้าที่รับผิดชอบ", field:"name",minWidth: 220, resizable:true, formatter:"textarea", mutator: customNameMutator},
      {//create column group
        title:"จำนวนครัวเรือน",
        columns:[
          {title:"บันทึก", field:"household_count.recorded", hozAlign:"right", width:100, headerSort:false, titleDownload:"จำนวนครัวเรือนที่บันทึก", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"อนุมัติ", field:"household_count.approved", hozAlign:"right", width:100, headerSort:false, titleDownload:"จำนวนครัวเรือนที่อนุมัติ", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
        ],
      },
      {//create column group
        title:"จำนวนครอบครัว",
        columns:[
          {title:"บันทึก", field:"family_count.recorded", hozAlign:"right", width:100, headerSort:false, titleDownload:"จำนวนครอบครัวที่บันทึก", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"อนุมัติ", field:"family_count.approved", hozAlign:"right", width:100, headerSort:false, titleDownload:"จำนวนครอบครัวที่อนุมัติ", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
        ],
      },
      {//create column group
        title:"จำนวนสมาชิก",
        columns:[
          {title:"บันทึก", field:"member_count.recorded", hozAlign:"right", width:100, titleDownload:"จำนวนสมาชิกที่บันทึก", headerSort:false, formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"อนุมัติ", field:"member_count.approved", hozAlign:"right", width:100, headerSort:false, titleDownload:"จำนวนสมาชิกที่อนุมัติ",formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
        ],
      },
      {//create column group
        title:"จำนวนครัวเรือนเปราะบาง",
        columns:[
          {title:"0", field:"fragile_level_count.level_0", hozAlign:"right", width:100, headerSort:false, titleDownload: "จำนวนครัวเรือนเปราะบางระดับ 0", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"1", field:"fragile_level_count.level_1", hozAlign:"right", width:100, headerSort:false, titleDownload: "จำนวนครัวเรือนเปราะบางระดับ 1", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"2", field:"fragile_level_count.level_2", hozAlign:"right", width:100, headerSort:false, titleDownload: "จำนวนครัวเรือนเปราะบางระดับ 2", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
          {title:"3", field:"fragile_level_count.level_3", hozAlign:"right", width:100, headerSort:false, titleDownload: "จำนวนครัวเรือนเปราะบางระดับ 3", formatter:
            function(cell, formatterParams){
              return cell.getValue() ? cell.getValue() : 0
            }
          },
        ],
      },
    ])
    const countCard = reactive([
      {
        text: "จำนวนครัวเรือน",
        recorded_count: null,
        approved_count: null,
        icon: "house",
      },
      {
        text: "จำนวนครอบครัว",
        recorded_count: null,
        approved_count: null,
        icon: "family",
      },
      {
        text: "จำนวนสมาชิก",
        recorded_count: null,
        approved_count: null,
        icon: "member",
      },
      {
        text: "จำนวนครัวเรือนเปราะบาง",
        level_0: null,
        level_1: null,
        level_2: null,
        level_3: null,
        icon: "sensitive",
      },
    ]);
    const getOverAllReport = async () =>{
      try{
        const config = {
          url: `${process.env.VUE_APP_BASE_API}member/getReport1OverallStats/`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
          },
          data: props.filter
        }
        const result = await axios(config)
        if(result){
          countCard[0].recorded_count = result.data?.hhstats ? result.data.hhstats.recorded : 0
          countCard[0].approved_count = result.data?.hhstats ? result.data.hhstats.approved : 0
          countCard[1].recorded_count = result.data?.famstats ? result.data.famstats.recorded : 0
          countCard[1].approved_count = result.data?.famstats ? result.data.famstats.approved : 0
          countCard[2].recorded_count = result.data?.memberstats ? result.data.memberstats.recorded : 0
          countCard[2].approved_count = result.data?.memberstats ? result.data.memberstats.approved : 0
          countCard[3].level_0 = result.data?.fragilestats ? result.data.fragilestats.fg0 : 0
          countCard[3].level_1 = result.data?.fragilestats ? result.data.fragilestats.fg1 : 0
          countCard[3].level_2 = result.data?.fragilestats ? result.data.fragilestats.fg2 : 0
          countCard[3].level_3 = result.data?.fragilestats ? result.data.fragilestats.fg3 : 0
        }
      }
      catch(error){
        console.log("error",error);
        Swal.fire({
          icon: "warning",
          text: "ระบบผิดพลาด",
        });
      }

    }
    onMounted(()=>{
      getOverAllReport()
    })

    return {
      dataArrayTable,
      dataReport,
      countCard,
      paramsComputed,
      key
    }
  }
})
</script>
<style lang="scss">
/*#tree-tabulator.tabulator{
  .tabulator-tree-level-0 [tabulator-field="household_count"],
  .tabulator-tree-level-0 [tabulator-field="family_count"],
  .tabulator-tree-level-0 [tabulator-field="member_count"],
  .tabulator-tree-level-0 [tabulator-field="sensitive_level_count"] {
    text-align: center !important;
    justify-content: center !important;
  }
}*/
.flex-1-5{
  flex: 1.5;
}
</style>

